import Branch from '@/lib/Branch';
import Person from '@/lib/Person';
import { Question } from '@/lib/Question';
import Response from '@/lib/Response';
import Step from '@/lib/Step';
import store from '@/store';
import router from '@/router';
import { api } from '@/Api';
import { AxiosResponse } from 'axios';
import Section from "./Section";

export class ResponseGroup {

  public static load(id: any) {
    let currentBranch = store.state.currentBranch! as Branch;
    return api.loadResponseGroup(id == "0" ? currentBranch.id : 0, id).then(
      ((response: AxiosResponse) => {
        if (response.status === 200) {
          const data = response.data.data;
          let responseGroup: ResponseGroup;
          responseGroup = store.getters.responseGroup(id);
          let currentBranch = store.state.currentBranch;
          if (null === currentBranch) {
            currentBranch = store.getters.getBranch(data.branch.id);
            store.commit('setCurrentBranch', currentBranch);
          }
          if (typeof responseGroup === typeof undefined) {
            responseGroup = new ResponseGroup(store.state.currentBranch!, data.creationDateFormatted);
            responseGroup.id = data.id;
            store.commit('addResponseGroup', responseGroup);
          }
          const rawResponses = data.responses;
          rawResponses.forEach((rawResponse: any) => {
            let question = store.getters.getQuestion(rawResponse.question.id);
            if (!question) {
              return;
            }
            if (rawResponse.additionalIndex > 0) {
              const additional = question.section.getAdditionalOrCreateIfNotExist(rawResponse.additionalIndex);
              question = additional.questions.find(
                (additionalQuestion: Question) => additionalQuestion.originalId === rawResponse.question.id,
              );
              if (!question) {
                return;
              }
            }
            if (question) {
              const responseObject = new Response(
                question,
                responseGroup,
                Question.transformBack(rawResponse.value, question.responseType.template),
                rawResponse.comment,
                rawResponse.valueId,
                rawResponse.id,
                rawResponse.customData,
              );
              responseObject.additionalIndex = rawResponse.additionalIndex;
              store.commit('addResponse', responseObject);
              question.currentResponse = responseObject;
            }

          });
          responseGroup.isLoaded = true;

          store.commit('setCurrentResponseGroup', responseGroup);
          store.commit('setCurrentStep', responseGroup.getCurrentStep());
        }
      }));
  }

  public id: any = "0";
  public person?: Person;
  public lastQuestion?: Question;
  public responses: Response[] = [];
  public currentStep?: Step;
  public isLoaded = false;
  public contractGroup?: any;

  constructor(public branch: Branch, public creationDateFormatted: string = '') {
  }

  public getCurrentStep() {
    if (!this.currentStep) {

      if (this.branch.steps.length) {

        for (let key in this.branch.steps) {
          let step = this.branch.steps[key];
          step.validate();
          if (!step.isValid || parseInt(key) === (this.branch.steps.length - 1)) {
            this.currentStep = step;
            return this.currentStep;
          }
        }
      } else {
        return null;
      }
    }
    return this.currentStep;
  }

  public nextStep() {
    const step = this.getCurrentStep();
    const index = this.branch.steps.findIndex((branchStep: Step) => branchStep.id === step!.id);
    let currentStep = step;
    if (index < (this.branch.steps.length - 1)) {
      currentStep = this.branch.steps[index + 1];
      this.currentStep = currentStep!;
      if (!this.currentStep.sections.some((section: Section) => section.canDisplay())) {
        this.nextStep();
      }
      store.commit('setCurrentStep', this.currentStep);
    } else {
      if (this.branch.activateComparison) {
        if (router.currentRoute.name !== 'comparisonResult' || router.currentRoute.params.responseGroupId !== this.id) {
          // @ts-ignore
          console.log('redirect from rg.ts')
          console.log(router.currentRoute.name)
          console.log(router.currentRoute.params.responseGroupId)
          router.push({ name: 'comparisonResult', params: { responseGroupId: this.id } });
        }
      } else {
        this.requestQuotation();
      }

    }

  }

  public requestQuotation() {
    store.commit('loading');
    api.requestQuotation(this.id).then((response: AxiosResponse) => {
      if (response.status >= 200 && response.status <= 299) {
        store.commit("openModal", { type: 'no-comparison-message' });
        store.commit('loaded');
      }
    });
  }

  public previousStep() {
    const step = this.getCurrentStep();
    const index = this.branch.steps.findIndex((branchStep: Step) => branchStep.id === step!.id);
    if (index > 0) {
      this.currentStep = this.branch.steps[index - 1];
    }
    store.commit('setCurrentStep', this.currentStep);
  }

  public stepIsFirst() {
    const step = this.getCurrentStep();
    const index = this.branch.steps.findIndex((branchStep: Step) => branchStep.id === step!.id);
    return index > -1 ? index === (this.branch.steps.length - 1) : false;
  }

  public stepIsLast() {
    const step = this.getCurrentStep();
    const index = this.branch.steps.findIndex((branchStep: Step) => branchStep.id === step!.id);
    return index > -1 ? index === 0 : false;
  }


}
